import { SquareTerminal } from "lucide-react";
import type { DockPanel } from "../../../../stores/dock";
import type { DockKindDef } from "../../registry";
import { TerminalPanel } from "./TerminalPanel";

/** Monotonic per-session counter. Terminal panels need DISTINCT ids (each is a
 *  separate shell — unlike an artifact, whose id is a content hash and whose
 *  re-open should focus the existing tab). A counter rather than Math.random()
 *  keeps ids deterministic for tests and any future persisted layout, matching
 *  the store's own slot/stack id convention. */
let _seq = 0;

/** Test seam, mirroring the store's `__resetSlotSeq`. */
export function __resetTerminalSeq(): void {
	_seq = 0;
}

/** Mint a new terminal panel. This is what makes the terminal the FIRST kind the
 *  rail can actually create: an artifact arrives from the chat and cannot be
 *  conjured, so `create` stayed a named seam until something could fill it. */
export function newTerminalPanel(): DockPanel {
	_seq += 1;
	return {
		id: `terminal-${_seq}`,
		kind: "terminal",
		// Numbered, not "Terminal, Terminal, Terminal" — a strip of identical
		// labels cannot be navigated, which is the same reason artifacts derive
		// their titles from their content.
		title: _seq === 1 ? "Terminal" : `Terminal ${_seq}`,
	};
}

export const terminalKind: DockKindDef = {
	tabIcon: () => <SquareTerminal size={13} />,
	Body: TerminalPanel,
	create: newTerminalPanel,
};
